import React from 'react'
import { Box, Typography, styled } from '@mui/material'

const ResponsiveImage = styled('img')(() => ({
  borderWidth: '2px',
  borderColor: '#ddd',
  borderStyle: 'solid',
  borderRadius: '10px',
  marginRight: '20px',
  width: '100px',
  hight: '100px',
  objectFit: 'contain'
}));

export default function WorkExperience() {

  return (
    <Box>

      <Box sx={{ pl:0.5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <ResponsiveImage sx={{padding: '25px'}} className="responsive-image" src='/static/works/google_logo.png' alt="Google logo" />
        <Box>
          <Typography sx={{fontSize: '0.9rem', color: 'grey.500', fontWeight: 'bold'}}>2026.11-2027.03 (Expected)</Typography>
          <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}>Student Researcher @ <a href='https://research.google/' target='_blank' rel="noreferrer">Google</a></Typography>
          <Typography>Sunnyvale, CA, USA</Typography>
          <Typography>Host: <a href='https://research.google/people/107150/' target='_blank' rel="noreferrer">Long T. Le</a></Typography>
        </Box>
      </Box>

      <Box sx={{ mt: 2, pl:0.5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <ResponsiveImage sx={{padding: '25px'}} className="responsive-image" src={'/static/works/Microsoft_logo.png'} alt="Logo" />
        <Box>
          <Typography sx={{fontSize: '0.9rem', color: 'grey.500',fontWeight: 'bold'}}>2026.06-2026.08</Typography>
          <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>Research Intern @ <a href='https://microsoft.github.io/debug-gym/' target='_blank' rel="noreferrer" style={{ marginLeft: '5px' }}>Microsoft Research</a></Typography>
          <Typography>Montréal, Canada</Typography>
          <Typography>Host: <a href='https://shizhengyan.github.io/' target='_blank' rel="noreferrer">Zhengyan Shi</a>, <a href='https://xingdi-eric-yuan.github.io/' target='_blank' rel="noreferrer">Eric Yuan</a></Typography>
        </Box>
      </Box>

      <Box sx={{ mt: 2, pl:0.5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <ResponsiveImage sx={{padding: '25px'}} className="responsive-image" src={'/static/works/Microsoft_logo.png'} alt="Logo" />
        <Box>
          <Typography sx={{fontSize: '0.9rem', color: 'grey.500',fontWeight: 'bold'}}>2025.09-2026.05</Typography>
          <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>Research Intern @ <a href='https://www.microsoft.com/en-us/research/project/agent-lightning/' target='_blank' rel="noreferrer" style={{ marginLeft: '5px' }}>Microsoft Research</a></Typography>
          <Typography>Shanghai, China</Typography>
           <Typography>Host: <a href='https://www.alphaxiv.org/@xufang-luo' target='_blank' rel="noreferrer">Xufang Luo</a>, <a href='https://www.microsoft.com/en-us/research/people/yuqyang/' target='_blank' rel="noreferrer">Yuqing Yang</a></Typography>
        </Box>
      </Box>


      {/* <Box sx={{ mt: 2, pl:0.5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <ResponsiveImage sx={{padding: '5px'}} className="responsive-image" src={'/static/works/snu.png'} alt="Logo" />
        <Box>
          <Typography sx={{fontSize: '0.9rem', color: 'grey.500',fontWeight: 'bold'}}>2025.03-2025.09</Typography>
          <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>Research Intern @ <a href='http://milab.snu.ac.kr/' target='_blank' rel="noreferrer" style={{ marginLeft: '5px' }}>Machine Intelligence Lab, SNU</a></Typography>
          <Typography>Seoul, South Korea</Typography>
        </Box>
      </Box> */}

      <Box sx={{ mt: 2, pl:0.5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <ResponsiveImage sx={{padding: '0px'}} className="responsive-image" src={'/static/works/lgresearch.jpg'} alt="Logo" />
        <Box>
          <Typography sx={{fontSize: '0.9rem', color: 'grey.500',fontWeight: 'bold'}}>2024.03-2024.12</Typography>
          <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>Research Intern @ <a href='https://www.lgresearch.ai/' target='_blank' rel="noreferrer" style={{ marginLeft: '5px' }}>LG AI Research</a></Typography>
          <Typography>Seoul, South Korea</Typography>
           Host: Kanghoon Lee
        </Box>
      </Box>

      {/* <Box sx={{ mt: 2, pl:0.5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <ResponsiveImage sx={{padding: '5px'}} className="responsive-image" src={'/static/works/dearplants.jpg'} alt="Logo" />
        <Box>
          <Typography sx={{fontSize: '0.9rem', color: 'grey.500',fontWeight: 'bold'}}>2020.06-2021.11</Typography>
          <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>CEO @ Dearplants</Typography>
          <Typography>Daejeon, South Korea</Typography>
        </Box>
      </Box> */}
    </Box>
  )
}